import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const SmartKPIIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 24 24" title={t`Smart KPI`} {...props}>
    <Path
      d="M4 17A8 8 0 0 1 20 17"
      stroke="currentColor"
      strokeWidth={2.5}
      strokeLinecap="round"
    />
    <Path
      d="M12 17L15.5 11.5"
      stroke="currentColor"
      strokeWidth={2.5}
      strokeLinecap="round"
    />
    <Path
      d="M14 17a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
      fill="currentColor"
      strokeWidth={0}
    />
    <Path
      d="M20 1.5Q20.54 3.96 23 4.5Q20.54 5.04 20 7.5Q19.46 5.04 17 4.5Q19.46 3.96 20 1.5Z"
      fill="currentColor"
      strokeWidth={0}
    />
  </Icon>
);
